import { Link } from 'react-router-dom';

export default function MobileHeader() {
  return (
    <header className="flex-shrink-0 px-4 pt-safe pb-2 flex items-center justify-between md:hidden">
      <Link to="/dashboard"><img src="/logo-text.png" alt="Loud Neighbors" className="h-7" /></Link>
      <Link to="/dashboard"><img src="/logo-icon.png" alt="LN" className="h-8" /></Link>
    </header>
  );
}
